import React from "react";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { getInitials } from "../requests/utilities/helpers";
import { formatTimestamp } from "../../../helpers/helpers";
import Rating from "@mui/material/Rating";
import ImageIcon from "@mui/icons-material/Image";
import InputEntry from "./InputEntry";

function CategoryEntry(props) {
  const [isEditing, setIsEditing] = React.useState(false);

  const isAuthor =
    props.currentUser &&
    props.entry.store_team_member?.user_id === props.currentUser.user_id;
  const canDelete = isAuthor || props.currentUser?.is_admin;

  const getRatingValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return 0;
    }
    const numValue = Number(value);
    return isNaN(numValue) ? 0 : numValue;
  };

  const formatValue = () => {
    if (props.categoryType === "dollar") {
      return props.entry.value_float !== null
        ? `$${parseFloat(props.entry.value_float).toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}`
        : "$0.00";
    }
    if (props.categoryType === "percentage") {
      return props.entry.value_float !== null &&
        props.entry.value_float !== undefined
        ? `${props.entry.value_float}%`
        : null;
    }
    if (props.categoryType === "number") {
      return props.entry.value_float !== null &&
        props.entry.value_float !== undefined
        ? `${props.entry.value_float}`
        : null;
    }
    return null;
  };

  const numericValue = formatValue();

  if (isEditing) {
    return (
      <InputEntry
        entry={props.entry}
        category={props.category}
        post_logbook_category_entry={props.post_logbook_category_entry}
        setShowInput={setIsEditing}
        categoryType={props.categoryType}
        get_file_upload={props.get_file_upload}
      />
    );
  }

  return (
    <div className="w-full flex items-start gap-3">
      {/* Avatar */}
      <div className="w-9 h-9 rounded-full bg-violet-100 text-xs font-semibold text-violet-700 flex items-center justify-center mt-0.5 shrink-0">
        <p>{getInitials(props.entry.store_team_member.full_name)}</p>
      </div>

      {/* Content */}
      <div className="flex-1">
        {/* Star Rating */}
        {props.categoryType === "star" && (
          <div className="mb-1.5">
            <Rating
              name="read-only"
              value={getRatingValue(props.entry.value_float)}
              readOnly
              size="small"
            />
          </div>
        )}

        {/* Numeric Value */}
        {numericValue && (
          <div className="bg-slate-50 border border-slate-100 rounded-lg px-2.5 py-1 inline-block mb-1.5">
            <p className="text-slate-900 font-bold text-base">{numericValue}</p>
          </div>
        )}

        {/* Text Value */}
        {props.entry.value_text && (
          <p className="text-sm text-slate-800 leading-relaxed whitespace-pre-line">
            {props.entry.value_text}
          </p>
        )}

        {/* Metadata */}
        <p className="text-xs text-slate-400 mt-1.5">
          {props.entry.store_team_member.full_name} &middot;{" "}
          {formatTimestamp(props.entry.created_at)}
        </p>

        {/* Image Attachment */}
        {props.entry?.file_uploads?.length > 0 && (
          <div
            className="inline-flex items-center gap-1.5 mt-2 bg-violet-50 border border-violet-200 rounded-lg px-2.5 py-1.5 cursor-pointer hover:bg-violet-100 transition-colors"
            onClick={() =>
              props.get_file_upload(props.entry?.file_uploads?.[0])
            }
          >
            <ImageIcon style={{ fontSize: "14px", color: "#6d28d9" }} />
            <span className="text-xs font-medium text-violet-700">
              View image
            </span>
          </div>
        )}
      </div>

      {/* Edit / Delete Buttons */}
      {(isAuthor || canDelete) && (
        <div className="flex items-center gap-1.5 shrink-0">
          {isAuthor && (
            <div
              className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center cursor-pointer hover:bg-slate-200 transition-colors"
              onClick={() => setIsEditing(true)}
            >
              <EditOutlinedIcon style={{ fontSize: "16px", color: "#64748B" }} />
            </div>
          )}
          {canDelete && (
            <div
              className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center cursor-pointer hover:bg-slate-200 transition-colors"
              onClick={() => props.delete_logbook_category_entry(props.entry.uuid)}
            >
              <DeleteOutlinedIcon style={{ fontSize: "16px", color: "#64748B" }} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default CategoryEntry;
